<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-toc full-character-formatting" id="table-of-contents">
<div class="heading heading-with-title heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title case-upper">CONTENTS</h1>
</div>
</div>
</div>
</div>
<div class="toc-contents text">
<div class="toc-frontmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/untitled"><span class="item-title-text">Untitled</span></a></p>
</div>
</div>
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-entry-type-volume toc-item-element-container-group has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/vol001"><span class="item-title-text">Farewell to Dreams</span></a></p>
<p class="item-subtitle">Fatal Insomnia, Book #1</p>
</div>
<div class="toc-item toc-item-entry-type-volume toc-item-element-container-group has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/vol002" title="Link target outside of Sample"><span class="item-title-text">A Raging Dawn</span></span></p>
<p class="item-subtitle">Fatal Insomnia, Book #2</p>
</div>
<div class="toc-item toc-item-entry-type-volume toc-item-element-container-group has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/vol003" title="Link target outside of Sample"><span class="item-title-text">The Sleepless Stars</span></span></p>
<p class="item-subtitle">The Fatal Insomnia Trilogy Finale</p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/abouttheauthor" title="Link target outside of Sample"><span class="item-title-text">About the Author</span></span></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?a7603a38